import { checkToken } from '../util/checkToken';

export class TokenStorage {
  _storage

  constructor(storage) {
    this._storage = storage;
  }

  getToken() {
    const auth0Token = this._storage.getItem(process.env.TOKEN_NAME_AUTH0);
    return this._storage.getItem(`${checkToken(auth0Token) ? process.env.TOKEN_NAME_AUTH0 : process.env.TOKEN_NAME}`);
  }
  setToken(token) {
    return this._storage.setItem(`${checkToken(token) ? process.env.TOKEN_NAME_AUTH0 : process.env.TOKEN_NAME}`, token);  
  }
}
